import { ComponentProps } from "react";
import { useWindowSize } from "@hooks/useWindowSize";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type HighlightsLeadProps = {
  /** The classname of the component. */
  className?: string;
  /** The article to be displayed as the lead highlight. */
  cardProp: ComponentProps<typeof Card>;
};

/** This is the first article in the highlights component.
 * https://www.figma.com/design/50gwyNfDsv70dHaddmTd7k/BT-SG60--WEB---APP-?node-id=164-79055&m=dev
 */
const HighlightsLead = ({
  className,
  cardProp,
}: HighlightsLeadProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  const variant: CardVariations = {
    image: {
      position: "left",
      width: cn("w-1/2"),
    },
    content: {
      width: cn("w-1/2"),
      extraClass: cn(
        "bg-gray-850 text-center py-4 px-6 lg:bg-transparent lg:text-left lg:p-0 lg:pl-4"
      ),
      blurb: {
        extraClass: cn("font-public-sans text-base mt-2"),
      },
    },
    title: {
      color: cn("text-gray-850"),
      size: cn("text-4xl"),
      extraClass: cn(
        "text-white font-semibold lg:text-gray-850 leading-[1.8125rem] font-lct"
      ),
    },
    kicker: {
      color: cn("text-gray-515"),
      extraClass: cn("font-poppins text-4xs font-light leading-6"),
    },
  };

  return (
    <Card
      {...cardProp}
      className={className}
      thumbnail={isScreenLG ? cardProp.thumbnail : undefined}
      variations={variant}
    />
  );
};

export default HighlightsLead;
